import { gql } from '@apollo/client';

export const FindManyTrips = gql`
  query FindManyTrips {
    myTripsAsDriver {
      id
      departureDateTime
      arrivalDateTime
      departureLocation
      arrivalLocation
      hotelName
      hotelLocation
      distanceInKm
      estimatedDuration
      status
      guestDriverName
      guestDriverPhone
      pauses {
        id
        startedAt
        durationMinutes
        endedAt
      }
      linkedTripId
      linkedTrip {
        id
        departureLocation
        arrivalLocation
      }
      event {
        id
        name
      }
      transportation {
        id
        name
        type
      }
      driver {
        id
        firstName
        lastName
      }
      driverHasLicence
      driverMissingDocuments
      photos {
        id
        phase
        order
        photo
        createdAt
      }
    }
  }
`;

export const TRIP_BY_SHARE_TOKEN = gql`
    query TripByShareToken($token: String!) {
        tripByShareToken(token: $token) {
            id
            status
            departureLocation
            arrivalLocation
            departureDateTime
            arrivalDateTime
            distanceInKm
            estimatedDuration
            guestDriverName
            startedAt
            pauses {
                id
                startedAt
                durationMinutes
                endedAt
            }
            routeGeometry
            departureLatitude
            departureLongitude
            arrivalLatitude
            arrivalLongitude
            transportation {
                name
                type
                seats
            }
            driverLocations {
                latitude
                longitude
                timestamp
            }
        }
    }
`;

export const TripsForEvent = gql`
    query TripsForEvent($eventId: Int!) {
        tripsForEvent(eventId: $eventId) {
            id
            departureDateTime
            arrivalDateTime
            departureLocation
            arrivalLocation
            hotelName
            hotelLocation
            distanceInKm
            estimatedDuration
            status
            guestDriverName
            guestDriverPhone
            startedAt
            pauses {
                id
                startedAt
                durationMinutes
                endedAt
            }
            mapUrl
            departureLatitude
            departureLongitude
            arrivalLatitude
            arrivalLongitude
            linkedTripId
            linkedTrip {
                id
                departureLocation
                arrivalLocation
            }
            transportation {
                id
                name
                type
                seats
            }
            driver {
                id
                firstName
                lastName
            }
            driverHasLicence
            driverMissingDocuments
            photos {
                id
                phase
                order
                photo
                createdAt
            }
            driverLocations {
                id
                latitude
                longitude
                timestamp
            }
            seatAssignments {
                id
                seatNumber
                playerId
                cautionPaid
                player {
                    id
                    firstName
                    lastName
                    profile {
                        pictureThumbnail
                    }
                }
            }
        }
    }
`;

export const TRIP_ROUTE_GEOMETRY = gql`
    query TripRouteGeometry($tripId: Int!) {
        tripRouteGeometry(tripId: $tripId)
    }
`;
